/**
 * Cinematic motion tokens — shared across every customer surface so the
 * whole site reads as a single film, not five different ones.
 *
 * Restrained-cinematic dial (Kiran 2026-06-08): slow, confident reveals;
 * never gimmicky. Every primitive that consumes these tokens MUST also
 * respect `prefers-reduced-motion` and collapse to a 0.2s opacity fade.
 */

/** The one ease curve. Slight overshoot-into-rest — feels human. */
export const EASE: readonly [number, number, number, number] = [0.22, 1, 0.36, 1]

/** Three durations. Pick by intent, not by feel. */
export const DURATION = {
  /** small chrome moves: badges, sub-text, icon swaps */
  subtle: 0.4,
  /** the default cinematic reveal — copy, tiles, cards */
  standard: 0.7,
  /** hero / full-bleed openings that should breathe */
  hero: 1.1
} as const

/** Stagger step between siblings (parent staggerChildren). */
export const STAGGER = {
  tight: 0.05,
  /** the default — tiles, paragraphs */
  standard: 0.08,
  loose: 0.14
} as const

/** Distance the element travels into rest on a fade-up. */
export const TRAVEL = {
  tight: 16,
  standard: 24,
  hero: 40
} as const
